export default {
  sales: [],
  loading: false
};



// WEBPACK FOOTER //
// ./src/modules/sales-detail/state.js